import type { ConceptDef } from '../types';

export const moneyRecognition: ConceptDef = {
  kind: 'tileMatch',
  id: 'money-recognition',
  label: 'Money Recognition',
  category: 'Math',
  description: 'Hear a coin or bill name; tap its value.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'a penny', answer: '1¢' },
      { say: 'a nickel', answer: '5¢' },
      { say: 'a dime', answer: '10¢' },
      { say: 'a quarter', answer: '25¢' },
      { say: 'a dollar', answer: '$1' },
    ],
  },
};
